import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import moment from 'moment'

export default {
  props: {},

  async created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    await this.getUser()

    this.userLevel = this.levels[this.institution.userType]

    this.createDate = this.formatDateTime(this.currentUser.createdAt)

    this.getDevices()
    this.searchUnidades()
  },

  data: () => ({
    institution: {},
    selectedUnidades: [],
    unidades: [],
    devices: [],
    step: 0,
    errorMessage: '',
    successMessage: '',
    loading: false,
    preferencesLoading: false,
    informationLoading: false,
    signatureLoading: false,
    removeLoading: false,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    alterDialog: false,
    changedData: false,
    showSuccess: false,
    error: false,
    removeSignatureDialog: false,
    buttonDisable: false,
    password: '',
    passwordConfirmation: '',
    userLevel: null,
    profileImage: null,
    profileImageData: null,
    professionalRegistration: null,

    signatureImageData: null,
    imageType: null,
    createDate: null,
    image: {
      height: 0,
      width: 0,
    },
    currentUser: {},
    userInstitutions: [],
    levels: [
      'Master',
      'Administrador',
      'Supervisor',
      'Operador',
      'Coordenador Op.',
      'Coordenado Setor Assinatura',
      'Solicitador',
    ],
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    emailRules: [
      (v) => !!v || 'E-mail requerido',
      (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
    ],
    phoneNumberRules: [
      (v) => !!v || 'Telefone requerido',
      (v) => (v && v.length > 13) || 'Telefone inválido',
    ],
    cellPhoneNumberRules: [
      (v) => !!v || 'Celular requerido',
      (v) => (v && v.length > 14) || 'Celular inválido',
    ],
    apiService: new ApiService(),
    fcmLoading: false,
  }),

  computed: {},

  methods: {
    async getUser() {
      this.loading = true

      await this.apiService
        .get(`user/${this.currentUser.id}`)
        .then((response) => {
          this.currentUser = response.content
          this.loading = false
          this.userInstitutions = response.content.institutions.map(
            (institution) => {
              return {
                ...institution.institution,
                ...institution,
                admissionDate: moment(
                  institution.admissionDate,
                  'YYYY-MM-DDThh:mm:sssZ'
                ).format('yyyy-MM-DD'),
                admissionDateAux: moment(
                  institution.admissionDate,
                  'YYYY-MM-DDThh:mm:sssZ'
                ).format('DD/MM/YYYY'),
                unidades: institution.unidades.map((unidade) => {
                  return unidade.unidadeId
                }),
                show: true,
              }
            }
          )

          // Filtra apenas as unidades da instituição logada
          const currentInstitution = this.userInstitutions.find(
            (inst) => inst.institutionId === this.institution.id
          )

          this.selectedUnidades = currentInstitution
            ? currentInstitution.unidades
            : []
        })
        .catch(() => {
          this.loading = false
        })
    },

    searchUnidades() {
      // Busca apenas as unidades da instituição logada
      this.apiService
        .post('unidade/listByIntitutionIds', { ids: [this.institution.id] })
        .then((response) => {
          this.unidades = response.content
        })
        .catch(() => {})
    },

    removeUnidade(item) {
      const index = this.selectedUnidades.indexOf(item.id)
      if (index > -1) {
        this.selectedUnidades.splice(index, 1)
      }
    },

    async enableDevice() {
      const userAgent = navigator.userAgent
      let browser = 5

      if (userAgent.match(/chrome|chromium|crios/i)) {
        browser = 2
      } else if (userAgent.match(/firefox|fxios/i)) {
        browser = 1
      } else if (userAgent.match(/safari/i)) {
        browser = 3
      } else if (userAgent.match(/opr\//i)) {
        browser = 0
      } else if (userAgent.match(/edg/i)) {
        browser = 4
      } else {
        browser = 5
      }

      let token = ''

      await this.$messaging
        .getToken(this.$messaging.messaging, {
          vapidKey:
            'BL3oaTl_6ICXaPRmp608zfqDqIj46_Xnx2F3weeKG7_ABZhRJd9LPKGrA7WDzA6p7A_LNgbobUw43HrUc3PjVhQ',
        })
        .then((currentToken) => {
          if (currentToken) {
            token = currentToken
          }
        })
        .catch((err) => {
          this.$toast.error(
            'Ocorreu um erro ao habilitar seu dispositivo, verifique as permissões de notificação e pop ups do site!'
          )
          return
        })

      if (token) {
        let device = 0

        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          // true for mobile device
          device = 1
        }

        this.fcmLoading = true
        this.apiService
          .post('userFCM', {
            token,
            browser,
            device,
          })
          .then(() => {
            this.$toast.success('Dispositivo habilitado com sucesso!')
            this.getDevices()
            this.fcmLoading = false
          })
          .catch(() => {
            this.fcmLoading = false
          })
      }
    },

    getDevices() {
      this.fcmLoading = true
      this.apiService
        .get('userFCM')
        .then((response) => {
          this.devices = response.content
          this.fcmLoading = false
        })
        .catch(() => {
          this.fcmLoading = false
        })
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    showSuccessAlert(message) {
      this.successMessage = message

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },

    saveProfileImage(value) {
      if (value) {
        this.profileImage =
          value.size < 2000000 ? URL.createObjectURL(value) : null
        this.imageType = value.type.split('/')[1]

        var reader = new FileReader()
        reader.readAsDataURL(value)
        reader.onload = () => {
          this.profileImageData = reader.result
        }
      } else {
        this.profileImage = null
        this.imageType = null
      }
    },

    saveSignatureImage(value) {
      if (value) {
        this.signatureImage = ''
        this.buttonDisable = false
        this.error = false
        this.errorMessage = ''

        var reader = new FileReader()
        reader.readAsDataURL(value)
        reader.onload = (evt) => {
          let img = new Image()
          img.src = evt.target.result
          img.onload = () => {
            if (img.width > 321 && img.height > 100) {
              this.error = true
              this.errorMessage =
                'Imagem inválida: A imagem da assinatura deve possuir no máximo 320x99 pixels'
              this.buttonDisable = true
            } else {
              this.signatureImage = img.size > 2000000 ? '' : img.src
              this.imageType = value.type.split('/')[1]
              this.signatureImageData = img.src
              this.currentUser.signatureImage = img.src
            }
          }
        }
      } else {
        this.signatureImage =
          this.currentUser.signatureImage != null
            ? `data:image/png;base64,${this.currentUser.signatureImage}`
            : ''
        this.imageType = null
      }
    },

    async submitPreferences() {
      if (this.$refs.firstForm.validate()) {
        this.preferencesLoading = true

        const userEditModel = {
          ...this.currentUser,
          Id: this.currentUser.id,
          Name: this.currentUser.name,
          Email: this.currentUser.email,
          Password: this.password,
          ProfileImage: this.profileImageData,
          FileType: this.imageType,
          EditUserType: 1,
          professionalRegistration: this.currentUser.professionalRegistration,
        }

        await this.apiService
          .post('user/edit', userEditModel)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert('Preferências atualizadas com sucesso')
            this.changedData = false
            this.currentUser.profileImage = response.content.profileImage
            localStorage.setItem('user', JSON.stringify(this.currentUser))
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.preferencesLoading = false
    },

    async submitInformation() {
      if (this.$refs.secondForm.validate()) {
        this.informationLoading = true

        // Atualiza as unidades da instituição logada
        const updatedInstitutions = this.userInstitutions.map((inst) => {
          if (inst.institutionId === this.institution.id) {
            return {
              ...inst,
              unidades: this.selectedUnidades.map((id) => {
                return { unidadeId: id }
              }),
            }
          }
          return inst
        })

        const userEditModel = {
          ...this.currentUser,
          Id: this.currentUser.id,
          PhoneNumber: this.currentUser.phoneNumber,
          CellPhoneNumber: this.currentUser.cellPhoneNumber,
          institutions: updatedInstitutions.map((institution) => {
            return {
              institutionId: institution.institutionId ?? institution.id,
              userType: institution.userType,
              userOffice: institution.userOffice,
              admissionDate: institution.admissionDate,
              manHourCost: institution.manHourCost,
              cellPhoneNumber: institution.cellPhoneNumber,
              unidades: institution.unidades,
            }
          }),
          audioInCalleds: this.currentUser.audioInCalleds,
          EditUserType: 2,
        }

        await this.apiService
          .post('user/edit', userEditModel)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert('Informações atualizadas com sucesso')
            this.changedData = false
            localStorage.setItem('user', JSON.stringify(response.content))
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.secondForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.informationLoading = false
    },

    async submitSignature() {
      if (this.$refs.thirdForm.validate()) {
        this.signatureLoading = true

        const userEditModel = {
          ...this.currentUser,
          Id: this.currentUser.id,
          SignatureImage: this.signatureImageData,
          FileType: this.imageType,
          EditUserType: 3,
        }

        await this.apiService
          .post('user/edit', userEditModel)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert('Assinatura salva com sucesso')
            this.changedData = false
            this.currentUser.signatureImage = response.content.signatureImage
            localStorage.setItem('user', JSON.stringify(this.currentUser))
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.thirdForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.signatureLoading = false
    },

    async removeSignature() {
      this.removeLoading = true

      const user = {
        Id: this.currentUser.id,
        SignatureImage: null,
      }

      await this.apiService
        .delete('user/removeSignature', user)
        .then((response) => {
          window.scrollTo(0, 0)
          this.showSuccessAlert(response.message)
          this.changedData = false
          this.removeSignatureDialog = false
          this.currentUser.signatureImage = null
          localStorage.setItem('user', JSON.stringify(this.currentUser))
          this.signatureImage = ''
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.removeLoading = false
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    currentUser: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
